import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
type ConfirmationProps = {
  keyValue: number | null;
  applyHandler?: () => void;
  cancelHandler?: () => void;
  close: () => void;
  email?: string;
};
const Confirmation = ({
  keyValue,
  applyHandler,
  cancelHandler,
  close,
  email,
}: ConfirmationProps) => {
  const { t } = useTranslation();
  const key = keyValue?.toString();
  switch (keyValue) {
    case 1:
      return (
        <>
          <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 2:
      return (
        <>
          {' '}
          <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 3:
      return (
        <>
          <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 4:
      return (
        <>
          <p>{t(`global.confirm.${key}`, { email })}</p>
          <Button color="danger" onClick={applyHandler}>
            {t('confirmation.confirmDelete')}
          </Button>{' '}
          <Button color="secondary" onClick={cancelHandler}>
            {t('confirmation.cancel')}
          </Button>
        </>
      );
    case 5:
      return (
        <>
          {' '}
          <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 6:
      return (
        <>
           <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 7:
      return (
        <>
          <p>{t(`global.confirm.${key}`)}</p>
          <Button color="danger" onClick={applyHandler}>
            {t('confirmation.confirmDelete')}
          </Button>{' '}
          <Button color="secondary" onClick={cancelHandler}>
            {t('confirmation.cancel')}
          </Button>
        </>
      );
    case 8:
      return (
        <>
           <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    case 9:
      return (
        <>
           <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
     case 10:
      return (
        <>
           <p>{t(`global.confirm.${key}`)}</p>
          <Button onClick={close} color="primary">
            Ok
          </Button>
        </>
      );
    default:
      return null;
  }
};
export default Confirmation;
